// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase"
const firebaseConfig = {
    apiKey: "AIzaSyBsR0-I_eh838wC26gsQ6WMpT4asPeVJmc",
    authDomain: "discord-clone-35f4b.firebaseapp.com",
    projectId: "discord-clone-35f4b",
    storageBucket: "discord-clone-35f4b.appspot.com",
    messagingSenderId: "902666389955",
    appId: "1:902666389955:web:650ffad06996808f0a9576",
    measurementId: "G-2M8ZRNNKHW"
  };
const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebaseApp.firestore();
const auth=firebase.auth()
const provider=new firebase.auth.GoogleAuthProvider();
export{auth, provider};
export default db;